import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useModalHandle
} from '@spotahome/ui-library';

import './CanIVisit.scss';

const CanIVisitButton = ({ isChecked }) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();
  const handleSendMetrics = () => {
    handleModalOpen();
  };

  return (
    <div>
      <Button
        color="link"
        onClick={handleSendMetrics}
        renderContent={() =>
          trans(
            isChecked
              ? 'listing.homechecker.header.fallback'
              : 'listing.help.can-visit'
          )
        }
      />
      <Modal
        contentLabel="modal"
        isOpen={isModalOpen}
        size="medium"
        className="can-visit"
        onRequestClose={handleModalClose}
      >
        <ModalHeader
          className="can-visit__header"
          label={trans(
            isChecked
              ? 'listing.homechecker.header.fallback'
              : 'listing.help.can-visit'
          )}
          onRequestClose={handleModalClose}
        />
        <ModalBody className="can-visit__body">
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: trans(
                isChecked
                  ? 'listing.help.can-visit.explanation'
                  : 'listing.help.can-not-visit.explanation'
              )
            }}
          />
        </ModalBody>
        <ModalFooter className="can-visit__footer">
          <Button onClick={handleModalClose} size="big">
            {trans('listing.help.can-visit.got-it')}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

CanIVisitButton.propTypes = {
  isChecked: PropTypes.bool.isRequired
};

export default CanIVisitButton;
